// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/planner_list_kind.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/planner_list_kind.proto.
 */
export const file_studyo_today_planners_v1_resources_planner_list_kind = /*@__PURE__*/
  fileDesc("CjpzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3BsYW5uZXJfbGlzdF9raW5kLnByb3RvEiJzdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzKssBCg9QbGFubmVyTGlzdEtpbmQSIQodUExBTk5FUl9MSVNUX0tJTkRfVU5TUEVDSUZJRUQQABIbChdQTEFOTkVSX0xJU1RfS0lORF9JTkJPWBABEhsKF1BMQU5ORVJfTElTVF9LSU5EX1RPREFZEAISHgoaUExBTk5FUl9MSVNUX0tJTkRfVVBDT01JTkcQAxIaChZQTEFOTkVSX0xJU1RfS0lORF9ET05FEAQSHwobUExBTk5FUl9MSVNUX0tJTkRfQ0FOQ0VMTEVEEAVCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.planners.v1.resources.PlannerListKind.
 */
export const PlannerListKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_planner_list_kind, 0);

/**
 * The kind of column represented by a PlannerList.
 *
 * @generated from enum studyo.today.planners.v1.resources.PlannerListKind
 */
export const PlannerListKind = /*@__PURE__*/
  tsEnum(PlannerListKindSchema);

